<template>
  <QuestionBase
      :question="question" :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
      :valid="!!data"
      :disabled-valid="true"
  >
    <InputBasic
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        :noSave="noSave"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../../QuestionBase";
import InputBasic from "../../../../inputs/InputBasic";

export default {
  name: 'StirpesAge',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    location: {
      type: String,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'At what age should any children inherit?',
        subTitle: null,
        tip: null
      },
      db: {
        saveLocation: 'product_will_data',
        saveField: `${this.location}${this.index}StirpesAge`,
        formPath: `data.${this.location}.details.gifts.${this.index}.stirpesAge`,
        jsonSaveField: 'stirpesAge',
      },
      args: {
        placeholder: 'e.g. 18',
        label: null,
        type: 'text',
        skippable: false,
        required: false,
        inputClass: 'field-66',
        prependText: 'Age'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>